import activity1 from "../Assets/activities/activity1/activity.json";
import activity2 from "../Assets/activities/activity2/activity.json";
import activity3 from "../Assets/activities/activity3/activity.json";
import activity4 from "../Assets/activities/activity4/activity.json";
import activity5 from "../Assets/activities/activity5/activity.json";
import activity6 from "../Assets/activities/activity6/activity.json";
import activityList from "../Assets/activities/activityList.json";

const activitiesArray = [
  activity1,
  activity2,
  activity3,
  activity4,
  activity5,
  activity6,
];

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    // Pick a random index from 0 to i
    const j = Math.floor(Math.random() * (i + 1));

    // Swap elements array[i] and array[j]
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function getActivity(activityName) {
  const activity = activitiesArray.find(
    (activity) => activity.name == activityName
  );
  if (!activity) {
    throw new Error(`Activity ${activityName} not found`);
  }
  return activity;
}

export function getActivityWorld(activityName) {
  activityName = activityList.find((a) => a.name == activityName)?.activity;
  const activity = activitiesArray.find(
    (activity) => activity.name == activityName
  );
  if (!activity) {
    throw new Error(`Activity ${activityName} not found`);
  }
  return activity.worldName;
}
